import { jsxs, jsx } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { BoxImpl, BoxInner } from "./box.styles.es.js";
const propTypes = {
  children: PropTypes.node,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
const defaultProps = {
  children: void 0,
  height: 32,
  width: "auto"
};
const Box = ({ children, height, width }) => /* @__PURE__ */ jsxs(BoxImpl, { $height: height, $width: width, children: [
  children && /* @__PURE__ */ jsx(BoxInner, { children }),
  /* @__PURE__ */ jsxs(
    "svg",
    {
      height: "100%",
      preserveAspectRatio: "none",
      viewBox: "0 0 100 100",
      width: "100%",
      children: [
        /* @__PURE__ */ jsx(
          "line",
          {
            stroke: "#D9D9D9",
            strokeWidth: 1,
            x1: 0,
            y1: 0,
            x2: "100%",
            y2: "100%"
          }
        ),
        /* @__PURE__ */ jsx(
          "line",
          {
            stroke: "#D9D9D9",
            strokeWidth: 1,
            x1: "100%",
            y1: 0,
            x2: 0,
            y2: "100%"
          }
        )
      ]
    }
  )
] });
Box.propTypes = propTypes;
Box.defaultProps = defaultProps;
export {
  Box
};
